import { render, staticRenderFns } from "./ModalAvoirCC.vue?vue&type=template&id=5ec1b5a8&"
import script from "./ModalAvoirCC.vue?vue&type=script&lang=js&"
export * from "./ModalAvoirCC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports